<script setup lang="ts">
import { computed } from 'vue'
import UploadPanel from '../components/UploadPanel/UploadPanel.vue'
import { useGameStore } from '../stores/game'

const store = useGameStore()
const missingTotal = computed(
  () => store.resources.reduce((total, resource) => total + resource.missing, 0)
)
</script>

<template>
  <div class="page-stack">
    <section class="page-heading">
      <div>
        <p class="eyebrow">任务资源</p>
        <h1>资源缺口</h1>
        <p>这里不是虚构库存，而是把所有活跃任务中的物品型目标合并成可核查的缺口表。</p>
      </div>
      <div v-if="store.loaded" class="status-card loaded">
        <span>合计仍缺</span>
        <strong>{{ missingTotal }}</strong>
        <small>{{ store.missingResourceCount }} 类材料</small>
      </div>
    </section>

    <UploadPanel v-if="!store.loaded" />

    <section class="content-panel">
      <p v-if="!store.loaded" class="empty-state">导入 v4 单文件后计算任务资源缺口。</p>
      <p v-else-if="store.resources.length === 0" class="empty-state">
        活跃任务中没有可映射的物品型目标。
      </p>
      <div v-else class="resource-table">
        <div class="resource-row resource-head">
          <span>资源</span>
          <span>当前 / 需求</span>
          <span>缺口</span>
          <span>关联任务</span>
        </div>
        <div
          v-for="resource in store.resources"
          :key="resource.key"
          class="resource-row"
          :class="{ ready: resource.ready }"
        >
          <div>
            <strong>{{ resource.name }}</strong>
            <small>{{ resource.itemId === null ? '未映射物品' : `物品 #${resource.itemId}` }}</small>
          </div>
          <b>{{ resource.current }} / {{ resource.required }}</b>
          <b>{{ resource.ready ? '已满足' : resource.missing }}</b>
          <small>{{ resource.questNames.join('、') }}</small>
        </div>
      </div>
    </section>
  </div>
</template>
